/* global translations */
/* eslint react/no-danger: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PaymentsStore from '../../stores/PaymentsStore';

class SubscriptionCoupon extends Component {
  state = {
    coupon: PaymentsStore.getCoupon(),
  };

  componentDidMount() {
    PaymentsStore.addCouponChangeListener(this.onCouponChange);
  }

  componentDidUpdate(prevProps) {
    const { active } = this.props;
    if (active !== prevProps.active) {
      PaymentsStore.setCouponFormOpen(false);
    }
  }

  onCouponChange = () => {
    this.setState({
      coupon: PaymentsStore.getCoupon(),
    });
  };

  showCouponForm = (e) => {
    e.preventDefault();
    PaymentsStore.setCouponFormOpen(true);
  };

  handleCouponInputChange = (e) => {
    PaymentsStore.setCouponData(null);
    PaymentsStore.setCouponCode(e.target.value);
    PaymentsStore.setCouponError(false);
  };

  render() {
    const { coupon } = this.state;
    const {
      code,
      data,
      used,
      formOpen,
      error,
    } = coupon;

    const messages = {
      error: (used ? 'txt: Kupona kods jau izmantots.' : 'txt: Kupona kods nav derīgs. Pārbaudiet to un mēģiniet vēlreiz.'),
      activated: get(translations, 'txt: Aktivizēts kupons: <b>{:coupon_code}</b>', 'Aktivizēts kupons: <b>{:coupon_code}</b>'),
    };

    // Message that coupon is activated, with coupon code and option to cancel
    if (data) {
      return (
        <div className="fr">
          <span dangerouslySetInnerHTML={{ __html: messages.activated.replace('{:coupon_code}', code) }} />
          <span className="mrxs" />
          <a
            href={PaymentsStore.getUrlQuery(false)}
            data-target="#main-panel"
            className="tcb remove-coupon-code"
          >
            {get(translations, 'txt: Atcelt', 'Atcelt')}
          </a>
        </div>
      );
    }

    // Offer to use coupon
    if (!formOpen) {
      return (
        <a
          className="paymentContainer-couponCodeText twb tcg "
          href="/"
          onClick={this.showCouponForm}
        >
          {get(translations, 'txt: Izmantot kupona kodu', 'Izmantot kupona kodu')}
        </a>
      );
    }

    // Coupon code input form with submit button and error message (if it should be shown)
    return (
      <div>
        {error === true && (
          <div className="mbxs form-group error">
            <div className="error">
              <div className="inner">
                {get(translations, messages.error, messages.error)}
              </div>
            </div>
          </div>
        )}
        <form
          className="paymentContainer-couponCodeInputForm"
          action={PaymentsStore.getUrlQuery()}
          method="post"
          data-target="#main-panel"
          data-disable-push="1"
        >
          <span className="mrs">
            {get(translations, 'txt: Ievadi kupona kodu:', 'Ievadi kupona kodu')}
          </span>
          <input
            id="CouponCode"
            className="btn paymentContainer-couponCodeInputField mrs"
            name="coupon_code"
            type="input"
            value={code}
            onChange={this.handleCouponInputChange}
          />
          <button className="btn btn--a btn--iconStatic tal" type="submit">
            {get(translations, 'txt: Aktivizēt', 'Aktivizēt')}
          </button>
        </form>
      </div>
    );
  }
}

SubscriptionCoupon.propTypes = {
  active: PropTypes.string,
};
SubscriptionCoupon.defaultProps = {
  active: '',
};

export default SubscriptionCoupon;
